import { render, staticRenderFns } from "./switches.vue?vue&type=template&id=05c12302"
import script from "./switches.vue?vue&type=script&lang=js"
export * from "./switches.vue?vue&type=script&lang=js"
import style0 from "./switches.vue?vue&type=style&index=0&id=05c12302&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports